import { render, staticRenderFns } from "./admin_product_select.vue?vue&type=template&id=faa7acce&scoped=true"
import script from "./admin_product_select.vue?vue&type=script&lang=js"
export * from "./admin_product_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa7acce",
  null
  
)

export default component.exports